import { createRoute } from '@tanstack/react-router'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Spaces/Space/Sharing'
import { mediaPlatformSpaceLayoutRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces/Space'

export const mediaPlatformSpaceSharingRoute = createRoute({
  getParentRoute: () => mediaPlatformSpaceLayoutRoute,
  path: StaticRouteParameter.SHARING,
  loader: () => null,
})

type MediaPlatformSpacesOverviewSearch = {
  query?: string
}

export const mediaPlatformSpaceSharingOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSpaceSharingRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformSpacesOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
